import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWalletFundOptions } from '../redux/buzzbridge/actions';
import { gettingWalletFundOptionsSelector, walletFundOptionsSelector } from '../redux/buzzbridge/selectors';

/** Loads GET /campaign-wallet/fund/options — country is server-detected only. */
export function useWalletFundOptions() {
    const dispatch = useDispatch();
    const fundOptions = useSelector(walletFundOptionsSelector);
    const loading = useSelector(gettingWalletFundOptionsSelector);

    useEffect(() => {
        dispatch(getWalletFundOptions());
    }, [dispatch]);

    return { fundOptions, loading, countryCode: fundOptions?.country_code ?? null };
}
